/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Tickets_Attachments_LabelInputs */

const en_settings_tickets_attachments_label = /** @type {(inputs: Settings_Tickets_Attachments_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Images (optional)`)
};

const zh_settings_tickets_attachments_label = /** @type {(inputs: Settings_Tickets_Attachments_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`图片附件(可选)`)
};

/**
* | output |
* | --- |
* | "Images (optional)" |
*
* @param {Settings_Tickets_Attachments_LabelInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const settings_tickets_attachments_label = /** @type {((inputs?: Settings_Tickets_Attachments_LabelInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Tickets_Attachments_LabelInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_settings_tickets_attachments_label(inputs)
	return zh_settings_tickets_attachments_label(inputs)
});
export { settings_tickets_attachments_label as "settings.tickets.attachments_label" }